export enum ReportType {
  CropGrossMargin = 'Crop Gross Margin',
  CropGrowingValuation = 'Crop Growing Valuation',
  CroppingSummary = 'Cropping Summary',
  FieldAudit = 'Field Audit',
  FieldGrossMargin = 'Field Gross Margin',
  FieldSummary = 'Field Summary',
  NMAXReport = 'N-max Report',
  NutrientSummary = 'Nutrient Summary',
  VarietyGrossMargin = 'Variety Gross Margin',
  WorkCompleted = 'Work Completed',
  StockTakingSheet = 'Stock Taking Sheet',
  StockValuation = 'Stock Valuation',
  LivestockManureNFarmLimit = 'Livestock Manure N Farm Limit'
}
